import {Injectable} from '@angular/core';
import { HttpClient } from '@angular/common/http';
import {API_URLS} from '../config/api.urls';
import {Observable} from 'rxjs';
import {IPagination} from '../_models/pagination';
import {ShippingType} from '../_models/shipping-type';
import {ShippingMean} from '../_models/shipping-mean';

@Injectable({
    providedIn: 'root'
})
export class ShippingMeanService {

    constructor(private httpClient: HttpClient) {
    }

    getAll(page: number): Observable<IPagination> {
        return this.httpClient.get<IPagination>(API_URLS.SHIPPING_MEANS_BASE_URL, {params: {page: page}});
    }

    addShippingMean(resource: any): Observable<any> {
        return this.httpClient.post(API_URLS.SHIPPING_MEANS_BASE_URL, resource);
    }

    updateShippingMean(shippingMeanId: number, resource: any): Observable<any> {
        return this.httpClient.put(API_URLS.SHIPPING_MEANS_BASE_URL + '/' + shippingMeanId, resource);
    }

    deleteShippingMean(shippingMeanId: number): Observable<any> {
        return this.httpClient.delete(API_URLS.SHIPPING_MEANS_BASE_URL + '/' + shippingMeanId);
    }

    getShippingTypes(): Observable<ShippingType[]>  {
        return this.httpClient.get<ShippingType[]>(API_URLS.SHIPPING_TYPES_BASE_URL);
    }

    addShippingOption(shippingTypeId: number, countryId: number): Observable<any> {
        return this.httpClient.post(API_URLS.SHIPPING_OPTIONS_BASE_URL, {
            shippingTypeId,
            countryId
        });
    }

    getShippingOptions(): Observable<any[]> {
        return this.httpClient.get<any[]>(API_URLS.SHIPPING_OPTIONS_BASE_URL);
    }

    getShippingOption(id: number): Observable<any> {
        return this.httpClient.get(`${API_URLS.SHIPPING_OPTIONS_BASE_URL}/${id}`);
    }

    updateShippingOption(id: number, shippingTypeId: number, countryId: number): Observable<any> {
        return this.httpClient.put(`${API_URLS.SHIPPING_OPTIONS_BASE_URL}/${id}`, {
            shippingTypeId,
            countryId
        });
    }

    deleteShippingOption(id: number): Observable<any> {
        return this.httpClient.delete(`${API_URLS.SHIPPING_OPTIONS_BASE_URL}/${id}`);
    }

    addShippingPricing(payload: any): Observable<any> {
        return this.httpClient.post(API_URLS.SHIPPING_PRICING_BASE_URL, payload);
    }

    getShippingPricings(shippingOptionId: number): Observable<any> {
        return this.httpClient.get(`${API_URLS.SHIPPING_PRICING_BASE_URL}?shippingOptionId=${shippingOptionId}`);
    }

    getShippingPricing(id: string): Observable<any> {
        return this.httpClient.get(`${API_URLS.SHIPPING_PRICING_BASE_URL}/${id}`);
    }

    updateShippingPricing(id: string, payload: any): Observable<any> {
        return this.httpClient.put(`${API_URLS.SHIPPING_PRICING_BASE_URL}/${id}`, payload);
    }

    deleteShippingPricing(id: string): Observable<any> {
        return this.httpClient.delete(`${API_URLS.SHIPPING_PRICING_BASE_URL}/${id}`);
    }

    getCitiesByCountry(countryId: number): Observable<any[]> {
        return this.httpClient.get<any[]>(`${API_URLS.CITIES_BASE_URL}?countryId=${countryId}`);
    }

    getAllShippingMeans(): Observable<ShippingMean> {
        return this.httpClient.get<ShippingMean>(API_URLS.SHIPPING_MEANS_UNAUTHENTICATED_BASE_URL);
    }

    getAvailableShippingOptions(countryId: number): Observable<any[]> {
        return this.httpClient.get<any[]>(`${API_URLS.SHIPPING_OPTIONS_BASE_URL}/available?countryId=${countryId}`);
    }

    getShippingPricingAll(shippingOptionId: number, productConditionId: number): Observable<any> {
        return this.httpClient
        .get(`${API_URLS.SHIPPING_PRICING_BASE_URL}/all?shippingOptionId=${shippingOptionId}&productConditionId=${productConditionId}`);
    }

}
